import { render } from "./relieve_data.vue?vue&type=template&id=6e3d7ac8&scoped=true"
import script from "./relieve_data.vue?vue&type=script&lang=js"
export * from "./relieve_data.vue?vue&type=script&lang=js"

import "./relieve_data.vue?vue&type=style&index=0&id=6e3d7ac8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3d7ac8"]])

export default __exports__